<template>
  <section class="app-main">
    <!-- appMain -->
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {},
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 87 = navbar + tags-view = 50 + 37 */
    min-height: calc(100vh - 78px);
  }

  .fixed-header + .app-main {
    padding-top: 78px;
  }
}
</style>
